module.exports = __webpack_public_path__ + "media/images/workplace/patterns/7-cd0bd2032a0fae08473e9ed4cc22265b.png";